<app-wizard-modal
    [isLoading]="isLoading"
    (cancel)="onWizardCancel()"
    (stepChange)="onStepChange($event)"
    (submit)="onWizardSubmit()">
    <app-wizard-title>{{
            (isEdit ? 'admin.toolMaintenancePlans.plans.modal.editTitle'
                : 'admin.toolMaintenancePlans.plans.modal.title') | translate
        }}
    </app-wizard-title>

    <app-wizard-step [canContinue]="detailsFormValid">
        <ng-template #title>{{ 'admin.toolMaintenancePlans.plans.modal.sections.details' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-maintenance-plan-details-form [showErrors]="step.nextTriggered">
            </app-maintenance-plan-details-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="toolsFormValid">
        <ng-template #title>{{ 'admin.toolMaintenancePlans.plans.modal.sections.tools' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-maintenance-plan-tools-form [showErrors]="step.nextTriggered"
                                             [maintenancePlanId]="plan?.id"
                                             [isEditMode]="isEdit">
            </app-maintenance-plan-tools-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canContinue]="activitiesFormValid">
        <ng-template #title>{{ 'admin.toolMaintenancePlans.plans.modal.sections.activities' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-maintenance-plan-activities-form>
            </app-maintenance-plan-activities-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{ 'admin.toolMaintenancePlans.plans.modal.sections.overview' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-maintenance-plan-overview [maintenancePlan]="plan"></app-maintenance-plan-overview>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
